/* eslint-disable no-var */
/* eslint-disable no-use-before-define */
/* eslint-disable vars-on-top */
import initJsBridge from "./jsbridge";
import CookieHelper from "js-cookie";
import wx from "weixin-js-sdk";

window.CookieHelper = CookieHelper;

let isIos = window.navigator.userAgent.indexOf('{"channel":"IOS"}') == -1;

isIos &&
  (function () {
    console.log("jsbridge init");
    if (window.WebViewJavascriptBridge) {
      return;
    }

    let messageHandlers = {};
    let responseCallbacks = {};
    let uniqueId = 1;
    let random = 1;

    function _doSend(message, responseCallback) {
      if (responseCallback) {
        let callbackId = `cb_${uniqueId++}_${new Date().getTime()}`;

        responseCallbacks[callbackId] = responseCallback;
        message["callbackId"] = callbackId;
      }

      let msg = JSON.stringify(message || {});

      if (window.WVJBInterface) {
        window.WVJBInterface.notice(msg);
      } else {
        // prompt('_wvjbxx', msg);
      }
    }

    let bridge = {
      registerHandler(handlerName, handler) {
        messageHandlers[handlerName] = handler;
      },

      callHandler(handlerName, data, responseCallback) {
        if (arguments.length == 2 && typeof data == "function") {
          responseCallback = data;
          data = null;
        }

        _doSend(
          {
            handlerName,
            data,
          },
          responseCallback
        );
      },
      disableJavascriptAlertBoxSafetyTimeout(disable) {
        this.callHandler(
          "_disableJavascriptAlertBoxSafetyTimeout",
          disable !== false
        );
      },
      _handleMessageFromJava(messageJSON) {
        _dispatchMessageFromJava(messageJSON);
      },
      hasNativeMethod(name, responseCallback) {
        this.callHandler("_hasNativeMethod", name, responseCallback);
      },
    };

    bridge.registerHandler("_hasJavascriptMethod", (data, responseCallback) => {
      responseCallback(!!messageHandlers[data]);
    });

    function _dispatchMessageFromJava(message) {
      let messageHandler;
      let responseCallback;

      if (message.responseId) {
        responseCallback = responseCallbacks[message.responseId];

        if (!responseCallback) {
          return;
        }

        responseCallback(message.responseData);
        delete responseCallbacks[message.responseId];
      } else {
        if (message.callbackId) {
          let callbackResponseId = message.callbackId;

          responseCallback = function (responseData) {
            _doSend({
              handlerName: message.handlerName,
              responseId: callbackResponseId,
              responseData,
            });
          };
        }

        let handler = messageHandlers[message.handlerName];

        if (!handler) {
          console.log(
            "WebViewJavascriptBridge: WARNING: no handler for message from java",
            message
          );
        } else {
          handler(message.data, responseCallback);
        }
      }
    }

    let callbacks = window.WVJBCallbacks;

    delete window.WVJBCallbacks;

    if (callbacks) {
      for (let i = 0; i < callbacks.length; i++) {
        callbacks[i](bridge);
      }
    }

    window.WebViewJavascriptBridge = bridge;

    window.close = function () {
      bridge.callHandler("_closePage");
    };
  })();



// 微信小程序环境
//const { wx } = window; // 小程序
if (typeof wx!="undefined" && wx.miniProgram) {
  wx.miniProgram.getEnv((res) => {
    if (res.miniprogram) {
      let appEnv = {
        version: "1.0.0",
        channel: "mp",
        isIPhoneXSeries: false,
        osversion: "",
        device: "wechat",
        method_prefix: "mp",
        start_path: "",
        storeCode: "",
      };

      window.appEnv = appEnv;
      localStorage.setItem("appEnv", JSON.stringify(appEnv));
    }
  });
}

initJsBridge();



// WEBPACK FOOTER //
// ./src/utils/jsbridge_init.js